/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var MoreIcon = createIcon("MoreIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "26",
    height: "18",
    viewBox: "0 0 26 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#more-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7a2 2 0 110 4 2 2 0 010-4Zm18 0a2 2 0 110 4 2 2 0 010-4Zm-9 0a2 2 0 110 4 2 2 0 010-4Z",
    fill: _color
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "more-a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "26",
    height: "18",
    fill: "#fff"
  }))));
}, {
  "replaceColor": true
});